import {components} from 'react-select';
import Option from 'react-select/src/components/Option';

const DropdownOption: typeof Option = props => {
    return (
        <components.Option {...props}>
            <li className="dfb-Dropdown-item"
                role="option"
                key={props.data.value}
                data-value={props.data.value}
                aria-selected={props.isSelected}
            >
                <div className="dfb-Dropdown-option">
                    <div className="dfb-Dropdown-optionLabel">{props.children}</div>
                </div>
            </li>
        </components.Option>
    );
};

export default DropdownOption;
